module.exports = __webpack_public_path__ + "img/arbitrum.150db383.svg";